<template>
  <div>
    <a v-if="isAttachmentNext()" :id="'g-'+content[index+1].id"></a>
    <div class="c-introduction" v-if="type === 1">
      <!--Main Section-->
      <header class="main-section-title">
        <h1>
          {{ row.title_1 }}
        </h1>
      </header>
      <div class="body-text-wrapper">
        <div class="body-text body-text--large" v-html="row.description_1"></div>
      </div>
    </div>

    <div class="section-block c-sub-section" v-if="type === 2">
      <!--Sub Main Section-->
      <a :id="'sub-'+row.id"></a>
      <div class="sub-section__title">
        <h2>
          {{ row.title_1 }}
        </h2>
      </div>
      <div class="body-text-wrapper">
        <div class="body-text body-text--small" v-html="row.description_1"></div>
      </div>
    </div>


    <div class="section-block c-main-title" v-if="type === 3">
      <!--Main Title-->
      <div class="main-title__title">
        <h3>
          {{ row.title_1 }}
        </h3>
      </div>
      <div class="body-text-wrapper">
        <div class="body-text body-text--small" v-html="row.description_1"></div>
      </div>
    </div>

    <div class="section-block c-sub-title" v-if="type === 4">
      <!--Sub Title-->
      <div class="sub-title__title">
        <h4>
          {{ row.title_1 }}
        </h4>
      </div>
      <div class="body-text-wrapper">
        <div class="body-text body-text--small" v-html="row.description_1"></div>
      </div>
    </div>

    <div class=" c-divider" v-if="type === 5">
      <!--Divider-->
      <div class="c-divider__line"></div>
    </div>

    <div class="section-block c-full-image" v-if="type === 6">
      <!--Full Image-->
      <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
        <source :src="row.image_1"/>
      </video>
      <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
      <div class="image-caption image-caption--full">
        <div class="image-caption__text">
          <span class="caption-title">
            {{ row.title_1 }}
          </span>
          <span class="image-caption__text_inline" v-html="row.description_1"></span>
        </div>
      </div>
    </div>

    <div class="section-block c-half-col-grid" v-if="type === 7">
      <!--Two col images-->
      <ul class="col-grid-50">
        <li class="col-grid-50__item">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_1 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_1"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-50__item">
          <video v-if="row.image_2 && fileExec(row.image_2)==='mp4'" controls width="100%">
            <source :src="row.image_2"/>
          </video>
          <img v-if="row.image_2 && fileExec(row.image_2)!=='mp4'" :src="row.image_2">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_2 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_2"></span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="section-block c-two-one-grid" v-if="type === 8">
      <!--Two One Col Images-->
      <ul class="col-grid-two-one">
        <li class="col-grid-two-one__item col-grid-two-one__item--65">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_1 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_1"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-two-one__item col-grid-two-one__item--35">
          <video v-if="row.image_2 && fileExec(row.image_2)==='mp4'" controls width="100%">
            <source :src="row.image_2"/>
          </video>
          <img v-if="row.image_2 && fileExec(row.image_2)!=='mp4'" :src="row.image_2">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_2 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_2"></span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="section-block c-three-col-grid" v-if="type === 9">
      <!-- Three Col Images-->
      <ul class="col-grid-33">
        <li class="col-grid-33__item">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_1 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_1"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-33__item">
          <video v-if="row.image_2 && fileExec(row.image_2)==='mp4'" controls width="100%">
            <source :src="row.image_2"/>
          </video>
          <img v-if="row.image_2 && fileExec(row.image_2)!=='mp4'" :src="row.image_2">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_2 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_2"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-33__item">
          <video v-if="row.image_3 && fileExec(row.image_3)==='mp4'" controls width="100%">
            <source :src="row.image_3"/>
          </video>
          <img v-if="row.image_3 && fileExec(row.image_3)!=='mp4'" :src="row.image_3">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_3 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_3"></span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="section-block c-four-col-grid" v-if="type === 10">
      <!-- Four Col Images-->
      <ul class="col-grid-25">
        <li class="col-grid-25__item">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_1 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_1"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-25__item">
          <video v-if="row.image_2 && fileExec(row.image_2)==='mp4'" controls width="100%">
            <source :src="row.image_2"/>
          </video>
          <img v-if="row.image_2 && fileExec(row.image_2)!=='mp4'" :src="row.image_2">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_2 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_2"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-25__item">
          <video v-if="row.image_3 && fileExec(row.image_3)==='mp4'" controls width="100%">
            <source :src="row.image_3"/>
          </video>
          <img v-if="row.image_3 && fileExec(row.image_3)!=='mp4'" :src="row.image_3">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_3 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_3"></span>
            </div>
          </div>
        </li>
        <li class="col-grid-25__item">
          <video v-if="row.image_4 && fileExec(row.image_4)==='mp4'" controls width="100%">
            <source :src="row.image_4"/>
          </video>
          <img v-if="row.image_4 && fileExec(row.image_4)!=='mp4'" :src="row.image_4">
          <div class="image-caption">
            <div class="image-caption__text">
              <span class="caption-title">{{ row.title_4 }}</span>
              <span class="image-caption__text_inline" v-html="row.description_4"></span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="section-block c-information-block" v-if="type === 11">
      <!--Information-->
      <div class="body-text-wrapper">
        <div v-html="row.description_1" class="body-text body-text--small"></div>
      </div>
    </div>

    <div class="section-block c-colors" v-if="type === 12">
      <!--Colors-->
      <ul class="colors-list">
        <li class="colors-list__item" v-for="i in 8" v-if="row['color_'+ i +'_hex']">
          <div class="color-circle" :style="{backgroundColor:row['color_'+ i +'_hex']}"></div>
          <div class="color-info">
            <span v-if="row['color_'+ i +'_hex']"><strong>HEX</strong> {{ row['color_' + i + '_hex'] }}</span>
            <span v-if="row['color_'+ i +'_c']">
              <strong>C</strong> {{ row['color_' + i + '_c'] }} <strong>M</strong> {{
                row['color_' + i + '_m']
              }} <strong>Y</strong> {{ row['color_' + i + '_y'] }} <strong>K</strong> {{ row['color_' + i + '_k'] }}
            </span>
            <span v-if="row['color_'+ i +'_pantone']"><strong>PANTONE</strong> {{ row['color_' + i + '_pantone'] }}</span>
          </div>
        </li>
      </ul>
    </div>


    <div class="section-block c-two-col-text" v-if="type === 13">
      <!--Two column Text-->
      <ul class="two-text-grid">
        <li class="two-text-grid__item">
          <div class="sub-title__title">
            <h4>{{ row.title_1 }}</h4>
          </div>
          <div class="body-text-wrapper">
            <div class="body-text body-text--small" v-html="row.description_1"></div>
          </div>
        </li>
        <li class="two-text-grid__item">
          <div class="sub-title__title">
            <h4>{{ row.title_2 }}</h4>
          </div>
          <div class="body-text-wrapper">
            <div class="body-text body-text--small" v-html="row.description_2"></div>
          </div>
        </li>
      </ul>
    </div>

    <div class="section-block c-full-image" v-if="type === 14">
      <div class="section-block-download">
        <a v-if="row.folder.zip_file" class="t-text-color" href="#" @click.prevent="download(row.folder,row.folder.name)">Download related assets
          <div v-if="loading === row.folder.id" class="loader"></div>
          <span v-else class="download-btn"></span>
        </a>
      </div>
    </div>


    <div class="section-block widget" :class="row.icon+'-widget'" v-if="type === 15">
      <i class="widget-icon " :class="'widget-icon--'+row.icon"></i>
      <div class="body-text-wrapper">
        <div class="body-text body-text--small" v-html="row.description_5">
        </div>
      </div>
    </div>


    <div class="section-block c-image-text" v-if="type === 16">
      <ul class="col-grid-50">
        <li class="col-grid-50__item">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
        </li>
        <li class="col-grid-50__item">
          <div class="body-title">
            <h4>{{ row.title_1 }}</h4>
          </div>
          <div class="body-text body-text--small" v-html="row.description_1"></div>
        </li>
      </ul>
    </div>

    <div class="section-block c-image-text" v-if="type === 17">
      <ul class="col-grid-50">
        <li class="col-grid-50__item">
          <div class="body-title">
            <h4>{{ row.title_1 }}</h4>
          </div>
          <div class="body-text body-text--small" v-html="row.description_1"></div>
        </li>
        <li class="col-grid-50__item">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
        </li>
      </ul>
    </div>

    <div class="section-block c-large-image-text" v-if="type === 18">
      <ul class="col-grid-two-one">
        <li class="col-grid-two-one__item col-grid-two-one__item--65">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
        </li>
        <li class="col-grid-two-one__item col-grid-two-one__item--35">
          <div class="body-title">
            <h4>{{ row.title_1 }}</h4>
          </div>
          <div class="body-text body-text--small" v-html="row.description_1"></div>
        </li>
      </ul>
    </div>

    <div class="section-block c-large-image-text" v-if="type === 19">
      <ul class="col-grid-two-one">
        <li class="col-grid-two-one__item col-grid-two-one__item--35">
          <div class="body-title">
            <h4>{{ row.title_1 }}</h4>
          </div>
          <div class="body-text body-text--small" v-html="row.description_1"></div>
        </li>
        <li class="col-grid-two-one__item col-grid-two-one__item--65">
          <video v-if="row.image_1 && fileExec(row.image_1)==='mp4'" controls width="100%">
            <source :src="row.image_1"/>
          </video>
          <img v-if="row.image_1 && fileExec(row.image_1)!=='mp4'" :src="row.image_1">
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  props: ['row', 'content', 'index'],
  mounted() {
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    type() {
      return this.row.type
    }
  },
  methods: {
    fileExec(filename) {
      return filename.split('.').pop().split(/\#|\?/)[0]
    },
    isAttachmentNext() {
      if (typeof this.content !== 'undefined' && typeof this.content[this.index + 1] !== 'undefined' && this.content[this.index + 1].type === 14) {
        return true
      }
      return false
    },
    download(folder, Name) {

      if (this.loading === false) {
        // var windowRef = window.open()
        this.loading = folder.id
        this.axios.get('/downloads/download?id=' + folder.id, {}).then((response) => {
          if (response.data.url) {
            this.runDownload(response.data.url, Name)
          }
        })
      }
    },
    async runDownload(url, Name) {
      await this.axios.get(url, {responseType: 'blob'}).then((response) => {
        const blob = new Blob([response.data], {type: 'application/zip'})
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = Name
        link.click()
        URL.revokeObjectURL(link.href)
        this.loading = false
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContentRow.vue